<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'propertyTagNfc.page.subTitle' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                  <button class="add-icon-button mr-2" color="primary" (click)="onAddTagNfc()" mat-flat-button
                    matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above">
                    <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'propertyTagNfc.addBtn' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="uid">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertyTagNfc.fields.uid' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.uid }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="uidFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(uidFilter)"
                        class="reset-input-icon" *ngIf="uidFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertyTagNfc.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- <a class="ml-2" (click)="onViewEditTagNfc(element)"> -->
                      {{ element.name }}
                    <!-- </a> -->
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="shortDescription">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md">
                    {{ 'propertyTagNfc.fields.shortDescription' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.shortDescription">
                      {{ 'propertyTagNfc.shortDescription.' + element.shortDescription | translate }}
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="shortDescriptionFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="externalPushButtonPanel">{{ 'propertyTagNfc.shortDescription.externalPushButtonPanel' | translate }}</mat-option>
                        <mat-option value="understairsPushButtonPanel">{{ 'propertyTagNfc.shortDescription.understairsPushButtonPanel' | translate }}</mat-option>
                        <mat-option value="dedicatedLocalAccessDoor">{{ 'propertyTagNfc.shortDescription.dedicatedLocalAccessDoor' | translate }}</mat-option>
                        <mat-option value="driveway">{{ 'propertyTagNfc.shortDescription.driveway' | translate }}</mat-option>
                        <mat-option value="other">{{ 'propertyTagNfc.shortDescription.other' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(shortDescriptionFilter)"
                        class="reset-input-icon ml-n3" *ngIf="shortDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="installationDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertyTagNfc.fields.installationDate' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.installationDate | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpInstallationDate" (focus)="dpInstallationDate.open()" (click)="dpInstallationDate.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="installationDateFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilter(installationDateFilter)" class="reset-input-icon"
                        *ngIf="installationDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpInstallationDate"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdBy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertyTagNfc.fields.createdBy' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.createdBy && element.createdBy.firstName !== ''">
                      {{ element.createdBy.firstName }} {{ element.createdBy.lastName }}
                    </span>
                    <span *ngIf="!element.createdBy">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="createdByFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdByFilter)"
                        class="reset-input-icon" *ngIf="createdByFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
               
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xs column-center">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                      <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item
                        (click)="onViewEditTagNfc(element)">
                        <mat-icon fontSet="fal" fontIcon="fa-pencil-alt" class="icon-action"></mat-icon>
                        {{ 'common.cta.modify' | translate }}
                      </button>
                      
                      <button mat-menu-item
                        (click)="onDeleteTagNfc(element)">
                        <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action">
                        </mat-icon>
                        {{ 'common.cta.cancel' | translate }}
                      </button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->